module.exports = __webpack_public_path__ + "img/Logo(en)_Light.570017f5.svg";